import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getReportProps = report => rowInfo => (
  rowInfo && rowInfo.row ? {
    reportId: report.id,
    mainReportId: ReportDefinitions.PREDES_COMPLIANCE.id,
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {}
);

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NavigationColumn,
    PercentageColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Sender', 'sender'),
        new NonZeroNumberColumn('Interchanges', 'interchanges'),
        new NonZeroNumberColumn('Despatches', 'despatches'),
      ],
    },
    {
      Header: 'Missing mandatory elements',
      columns: [
        new NavigationColumn(
          new NonZeroNumberColumn('#', 'missingMandatoryElements.no'),
          getReportProps(ReportDefinitions.PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_SUMMARY),
        ),
        new PercentageColumn('%', 'missingMandatoryElements.pct'),
      ],
    },
    {
      Header: 'Missing required elements',
      columns: [
        new NavigationColumn(
          new NonZeroNumberColumn('#', 'missingRequiredElements.no'),
          getReportProps(ReportDefinitions.PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_SUMMARY),
        ),
        new PercentageColumn('%', 'missingRequiredElements.pct'),
      ],
    },
    {
      Header: 'Message mapping errors',
      columns: [
        new NavigationColumn(
          new NonZeroNumberColumn('#', 'messageMappingErrors.no'),
          getReportProps(ReportDefinitions.PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_SUMMARY),
        ),
        new PercentageColumn('%', 'messageMappingErrors.pct'),
      ],
    },
    {
      Header: 'Sent to the wrong mailbox',
      columns: [
        new NonZeroNumberColumn('#', 'sentToWrongMailbox.no'),
        new PercentageColumn('%', 'sentToWrongMailbox.pct'),
      ],
    },
    {
      Header: 'Closed after planned arrival',
      columns: [
        new NavigationColumn(
          new NonZeroNumberColumn('#', 'closedAfterPlannedArrival.no'),
          getReportProps(ReportDefinitions.PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_SUMMARY),
        ),
        new PercentageColumn('%', 'closedAfterPlannedArrival.pct'),
      ],
    },
    {
      Header: 'Incorrect IMPC code',
      columns: [
        new NavigationColumn(
          new NonZeroNumberColumn('#', 'incorrectImpcCode.no'),
          getReportProps(ReportDefinitions.PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_SUMMARY),
        ),
        new PercentageColumn('%', 'incorrectImpcCode.pct'),
      ],
    },
    {
      Header: 'Incorrect IATA code',
      columns: [
        new NavigationColumn(
          new NonZeroNumberColumn('#', 'incorrectIataCode.no'),
          getReportProps(ReportDefinitions.PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_SUMMARY),
        ),
        new PercentageColumn('%', 'incorrectIataCode.pct'),
      ],
    },
    {
      Header: 'Mismatched subclass - receptacle ID vs despatch ID',
      columns: [
        new NavigationColumn(
          new NonZeroNumberColumn('#', 'mismatchedSubclass.no'),
          getReportProps(ReportDefinitions.MISMATCHED_SUBCLASS_RECEPTACLE_ID_VS_DESPATCH_ID),
        ),
        new PercentageColumn('%', 'mismatchedSubclass.pct'),
      ],
    },
    {
      Header: 'Gaps in interchange numbers',
      columns: [
        new NonZeroNumberColumn('#', 'gapsInInterchangeNumbers.no'),
        new PercentageColumn('%', 'gapsInInterchangeNumbers.pct'),
      ],
    },
    {
      Header: 'Gaps in despatch numbers',
      columns: [
        new NavigationColumn(
          new NonZeroNumberColumn('#', 'gapsInDespatchNumbers.no'),
          getReportProps(ReportDefinitions.PREDES_COMPLIANCE_GAPS_IN_DESPATCH_NUMBERS),
        ),
        new PercentageColumn('%', 'gapsInDespatchNumbers.pct'),
      ],
    },
  ];
};
